import './App.css';

function App() {
  return (
        window.location.href = "https://hermesprotocol.io"
  );
}

export default App;
